import Enumerable from "linq";
import { Point, Rectangle, Vector, Size } from "../../../../domain/drawing";
import { DragKinds } from "../../DragKinds";
import { ITransformable } from "../ITransformable";

export abstract class AbstractTransformer implements ITransformable {
  transformPoints(source: Point[], pointer: Point, kind: DragKinds): Point[] {
    const rectangle = Rectangle.from(source);
    const transformed = this.transformRectangle(rectangle, pointer, kind);
    const offset = transformed.topLeft.subtract(rectangle.topLeft);
    const ratio = new Size(
      this.calculateRatio(rectangle.width, transformed.width),
      this.calculateRatio(rectangle.height, transformed.height));
    return Enumerable.from(source)
      .select(p => {
        const offsetted = p.subtract(rectangle.topLeft);
        offsetted.x *= ratio.width;
        offsetted.y *= ratio.height;
        return offsetted.add(rectangle.topLeft.add(offset));
      })
      .toArray();
  }

  calculateRatio(source: number, destination: number): number {
    // 幅/高さが0になる事はありえるのでその場合は1として扱う.
    return destination / ((0 < source) ? source : 1);
  }

  abstract transformRectangle(source: Rectangle, pointer: Point, kind: DragKinds): Rectangle;
  abstract transformVector(source: Vector, pointer: Point, kind: DragKinds): Vector;

  protected isResizingToTop(kind: DragKinds): boolean {
    return (0 < (kind & DragKinds.Top));
  }

  protected isResizingToLeft(kind: DragKinds): boolean {
    return (0 < (kind & DragKinds.Left));
  }

  protected isResizingToBottom(kind: DragKinds): boolean {
    return (0 < (kind & DragKinds.Bottom));
  }

  protected isResizingToRight(kind: DragKinds): boolean {
    return (0 < (kind & DragKinds.Right));
  }

  protected isResizingVertical(kind: DragKinds): boolean {
    return this.isResizingToTop(kind)
        || this.isResizingToBottom(kind);
  }

  protected isResizingHorizontal(kind: DragKinds): boolean {
    return this.isResizingToLeft(kind)
        || this.isResizingToRight(kind);
  }

  protected isMovingFrom(kind: DragKinds): boolean {
    return (kind === DragKinds.From);
  }

  protected isMovingTo(kind: DragKinds): boolean {
    return (kind === DragKinds.To);
  }
}
